export enum SignUpStep {
  SignUp = 'sign-up',
  SendEmail = 'send-email',
  Success = 'success',
}
